class ComplementaryProductAdd extends HTMLElement {
  connectedCallback() {
    this._button = this.querySelector("button");
    this._status = this.querySelector('[role="status"]');
    this._isBusy = false;
    this._onClick = this._onClick.bind(this);
    this._onCartChange = this._onCartChange.bind(this);

    this._button?.addEventListener("click", this._onClick);
    document.addEventListener("cart:change", this._onCartChange);
  }

  disconnectedCallback() {
    this._button?.removeEventListener("click", this._onClick);
    document.removeEventListener("cart:change", this._onCartChange);
  }

  get variantId() {
    return this.getAttribute("variant-id");
  }

  _setState(state) {
    this._button.dataset.state = state;
  }

  async _onClick() {
    if (this._isBusy || this._button.dataset.state !== "add") {
      return;
    }

    this._isBusy = true;
    this._button.setAttribute("aria-busy", "true");

    const sections = ["variant-added"];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections } })
    );

    const formData = new FormData();
    formData.set("id", this.variantId);
    formData.set("quantity", "1");
    formData.set("sections", sections.join(","));
    formData.set("sections_url", `${window.Shopify.routes.root}variants/${this.variantId}`);

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        body: formData,
        headers: { "X-Requested-With": "XMLHttpRequest" }
      });
      const responseJson = await response.json();

      if (!response.ok) {
        throw new Error(responseJson["description"] || responseJson["message"]);
      }

      const cart = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
      cart["sections"] = responseJson["sections"];

      this.dispatchEvent(new CustomEvent("variant:add", {
        bubbles: true,
        detail: {
          items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
          cart,
          blockCartDrawerOpening: true
        }
      }));

      document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
        bubbles: true,
        detail: { baseEvent: "variant:add", cart }
      }));

      this._setState("added");
      if (this._status) {
        this._status.textContent = this._status.dataset.addedMessage || "";
      }
    } catch (error) {
      this._setState("add");
      this.dispatchEvent(new CustomEvent("cart:error", {
        bubbles: true,
        detail: { error: error.message }
      }));
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    } finally {
      this._button.removeAttribute("aria-busy");
      this._isBusy = false;
    }
  }

  _onCartChange(event) {
    if (this._button.dataset.state !== "added") {
      return;
    }

    const items = event.detail?.cart?.items;
    if (Array.isArray(items) && !items.some((item) => String(item["variant_id"]) === this.variantId)) {
      this._setState("add");
      if (this._status) {
        this._status.textContent = "";
      }
    }
  }
}

if (!window.customElements.get("complementary-product-add")) {
  window.customElements.define("complementary-product-add", ComplementaryProductAdd);
}
